import * as React from 'react';

import Radium from '@flipdish/radium';
import { connect } from 'react-redux';

import CheckBoxOld from '../../../ui/CheckboxOld/CheckboxOld';
import { Track } from '../../analytics';
import {
  AppConfig,
  AppDesignScheme,
  ContactFormType,
  Customer,
  Language,
} from '../../Api';
import { cookieConsent } from '../../cookieconsent';
import * as Data from '../../Data';
import * as Intercom from '../../intercom';
import { cookieSelectors } from '../../selectors';
import * as Store from '../../Store';
import { Utilities } from '../../Utilities';
import { AboutMyData } from '../SecureWarningModal/AboutMyData';
import { IconField } from './IconField';
import LinkField from './LinkField';

const tinycolor = require('tinycolor2');

interface InnerProps {
  ContactFormType: ContactFormType;
  Customer: Data.Async<Customer>;
  Intercom: Store.IntercomSettings;
  LogOut: () => any;
  RequestLogIn: () => any;
  SetSmsEnabled: (state: boolean) => any;
  Params: {
    vrid: number;
    type: 'collection' | 'delivery';
    id: number;
  };
  translate: any;
  ChangeLanguage: (lang: string) => any;
  AppConfig: Data.Async<AppConfig>;
  Languages: Store.Language[];
  SetCustomerName: (customerName: string) => any;
  SetCustomerEmail: (customerEmail: string) => any;
  AppDesignScheme: AppDesignScheme;
  isDark: boolean;
}

interface Props extends MappedState, InnerProps {}

interface MappedState {
  hasGdprCookieFeatureFlag: boolean;
  hasDisableNonEssentialCookies: boolean;
}

interface State {
  CurrentLanguage: string;
  CustomerName: string;
  Email: string;
  CurrentEmail: string;
}

class StatusDisplay extends React.Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context);

    let initialLang = 'en';

    for (const Language of props.Languages) {
      if (Language.active) {
        initialLang = Language.code;
        break;
      }
    }

    this.state = {
      CurrentLanguage: initialLang,
      CustomerName: '',
      Email: '',
      CurrentEmail: '',
    };
  }

  public UNSAFE_componentWillReceiveProps(newProps: Props) {
    if (newProps.Languages != this.props.Languages) {
      for (const Language of newProps.Languages) {
        if (Language.active) {
          this.setState({ CurrentLanguage: Language.code });
          break;
        }
      }
    }

    if (newProps.Customer.status === 'success') {
      if (newProps.Customer.data.CustomerName != this.state.CustomerName) {
        this.setState({ CustomerName: newProps.Customer.data.CustomerName });
      }

      if (newProps.Customer.data.EmailAddress != this.state.Email) {
        this.setState({ Email: newProps.Customer.data.EmailAddress });
      }

      if (newProps.Customer.data.EmailAddress != this.state.CurrentEmail) {
        this.setState({ CurrentEmail: newProps.Customer.data.EmailAddress });
      }
    }
  }

  public onPromotionsClick = () => {
    const { Customer, SetSmsEnabled } = this.props;
    if (Customer.status != 'success') {
      return;
    }
    Track('Profile', 'Receive Promotions', {
      event_label: (!Customer.data.SmsPromotionsEnabled).toString(),
    });
    SetSmsEnabled(!Customer.data.SmsPromotionsEnabled);
  };

  public loading(): JSX.Element {
    const { AppDesignScheme, isDark } = this.props;

    const styles = {
      sidepanel: {
        background: tinycolor(AppDesignScheme.Primary)
          .darken(3)
          .toString(),
        boxShadow: `1px 1px 9px -5px ${AppDesignScheme.Secondary}`,
        WebkitBoxShadow: `1px 1px 9px -5px ${AppDesignScheme.Secondary}`,
        borderColor: tinycolor(AppDesignScheme.Primary)
          .darken(20)
          .toString(),
      },
      darkSidepanel: {
        background: tinycolor(AppDesignScheme.Tertiary)
          .lighten(10)
          .toString(),
        borderColor: tinycolor(AppDesignScheme.Tertiary)
          .darken(10)
          .toString(),
        boxShadow: `1px 1px 9px -5px ${tinycolor(AppDesignScheme.Tertiary)
          .darken(10)
          .toString()}`,
        WebkitBoxShadow: `1px 1px 9px -5px ${tinycolor(AppDesignScheme.Tertiary)
          .darken(10)
          .toString()}`,
      },
    };

    return (
      <div
        className="menu__sidepanel"
        style={isDark ? styles.darkSidepanel : styles.sidepanel}
      >
        <button
          className="fd-button fd-button--full-width fd-button--secondary flex flex-align-center flex-justify-center block-center hidden-sm hidden-xs"
          disabled={true}
        >
          <span className="flex flex-align-center flex-justify-center">
            <i className="primary icon_refresh fd-spin" aria-hidden="true" />
            <p className="clear-margins primary fd-h4">
              {this.props.translate('Loading')}
            </p>
          </span>
        </button>
      </div>
    );
  }

  public contactUs = () => {
    Track('Profile', 'Contact Us');
    Intercom.ShowMessages(this.props.Intercom);
  };

  public renderContactUs = (): JSX.Element | null => {
    const { AppDesignScheme } = this.props;

    const styles = {
      link: {
        ':hover': {},
        ':active': {},
      },
      secondary: {
        color: AppDesignScheme.Secondary,
      },
      secondaryActive: {
        color: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString(),
      },
      tertiary: {
        color: AppDesignScheme.Tertiary,
      },
    };

    switch (this.props.ContactFormType) {
      case ContactFormType.Intercom:
        return (
          <div
            className="fd-nav flex flex-align-center menu__sidepanel__item menu__sidepanel__item--link"
            onClick={this.contactUs}
            style={styles.link as any}
            key="contact-us"
          >
            <i
              className="fa fa-at tertiary"
              style={
                Radium.getState(this.state, 'contact-us', ':active')
                  ? styles.secondaryActive
                  : Radium.getState(this.state, 'contact-us', ':hover')
                  ? styles.secondary
                  : styles.tertiary
              }
            />
            <p
              className="inline-block clear-margins tertiary fd-h4"
              style={
                Radium.getState(this.state, 'contact-us', ':active')
                  ? styles.secondaryActive
                  : Radium.getState(this.state, 'contact-us', ':hover')
                  ? styles.secondary
                  : styles.tertiary
              }
            >
              <u>{this.props.translate('Contact_us')}</u>
            </p>
          </div>
        );

      default:
        return null;
    }
  };

  public changeLanguage = (e: any) => {
    this.setState({ CurrentLanguage: e.target.value });
    this.props.ChangeLanguage((e.target as any).value);
  };

  public handleNameChange = (e) => {
    this.props.SetCustomerName(e.target.value);
  };

  public handleEmailChange = (e) => {
    this.setState({ Email: e.target.value });
  };

  public handleEmailBlur = () => {
    if (!Utilities.isValidEmail(this.state.Email)) {
      this.setState({ Email: this.state.CurrentEmail });
    } else {
      this.props.SetCustomerEmail(this.state.Email);
    }
  };

  public handlePrivacySettingsClick = () => {
    cookieConsent.edit();
  };

  public guestLoggedIn(): JSX.Element {
    const { AppDesignScheme, isDark, translate } = this.props;

    const styles = {
      sidepanel: {
        background: tinycolor(AppDesignScheme.Primary)
          .darken(3)
          .toString(),
        boxShadow: `1px 1px 9px -5px ${AppDesignScheme.Secondary}`,
        WebkitBoxShadow: `1px 1px 9px -5px ${AppDesignScheme.Secondary}`,
        borderColor: tinycolor(AppDesignScheme.Primary)
          .darken(20)
          .toString(),
      },
      darkSidepanel: {
        background: tinycolor(AppDesignScheme.Tertiary)
          .lighten(10)
          .toString(),
        borderColor: tinycolor(AppDesignScheme.Tertiary)
          .darken(10)
          .toString(),
        boxShadow: `1px 1px 9px -5px ${tinycolor(AppDesignScheme.Tertiary)
          .darken(10)
          .toString()}`,
        WebkitBoxShadow: `1px 1px 9px -5px ${tinycolor(AppDesignScheme.Tertiary)
          .darken(10)
          .toString()}`,
      },
      link: {
        ':hover': {},
        ':active': {},
      },
      primary: {
        color: AppDesignScheme.Primary,
      },
      secondary: {
        color: AppDesignScheme.Secondary,
      },
      secondaryActive: {
        color: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString(),
      },
      tertiary: {
        color: AppDesignScheme.Tertiary,
      },

      guestStatus: {
        fontWeight: 'bold',
      },
      phoneNumberloginAltLink: {
        color: AppDesignScheme.Tertiary,
        cursor: 'pointer',

        ':hover': {
          textDecoration: 'underline',
        },
      },
    };

    return (
      <div
        className="menu__sidepanel"
        style={isDark ? styles.darkSidepanel : styles.sidepanel}
      >
        <p style={styles.guestStatus as any}>
          {translate('menu_statusPanel_guestLoggedIn')}
        </p>

        <p
          className="clear-margins primary"
          data-fd="button-login"
          key="login-button"
          onClick={this.props.RequestLogIn}
          style={styles.phoneNumberloginAltLink}
        >
          {translate('menu_statusPanel_phoneNumberLoginAlt')}
        </p>
      </div>
    );
  }

  public loggedIn(customer: Customer): JSX.Element {
    const {
      Params,
      AppConfig,
      AppDesignScheme,
      isDark,
      translate,
    } = this.props;

    const styles = {
      sidepanel: {
        background: tinycolor(AppDesignScheme.Primary)
          .darken(3)
          .toString(),
        boxShadow: `1px 1px 9px -5px ${AppDesignScheme.Secondary}`,
        WebkitBoxShadow: `1px 1px 9px -5px ${AppDesignScheme.Secondary}`,
        borderColor: tinycolor(AppDesignScheme.Primary)
          .darken(20)
          .toString(),
      },
      darkSidepanel: {
        background: tinycolor(AppDesignScheme.Tertiary)
          .lighten(10)
          .toString(),
        borderColor: tinycolor(AppDesignScheme.Tertiary)
          .darken(10)
          .toString(),
        boxShadow: `1px 1px 9px -5px ${tinycolor(AppDesignScheme.Tertiary)
          .darken(10)
          .toString()}`,
        WebkitBoxShadow: `1px 1px 9px -5px ${tinycolor(AppDesignScheme.Tertiary)
          .darken(10)
          .toString()}`,
      },
      link: {
        ':hover': {},
        ':active': {},
      },
      primary: {
        color: AppDesignScheme.Primary,
      },
      secondary: {
        color: AppDesignScheme.Secondary,
      },
      secondaryActive: {
        color: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString(),
      },
      tertiary: {
        color: AppDesignScheme.Tertiary,
      },
      checkbox: {
        color: AppDesignScheme.Tertiary,
        ':hover': {
          color: AppDesignScheme.Secondary,
        },
        ':active': {
          color: tinycolor(AppDesignScheme.Secondary)
            .darken(10)
            .toString(),
        },
      },
      darkCheckbox: {
        color: AppDesignScheme.Primary,
        ':hover': {
          color: AppDesignScheme.Secondary,
        },
        ':active': {
          color: tinycolor(AppDesignScheme.Secondary)
            .darken(10)
            .toString(),
        },
      },
      dropdown: {
        color: AppDesignScheme.Tertiary,
        background: AppDesignScheme.Primary,
        borderColor: tinycolor(AppDesignScheme.Tertiary)
          .setAlpha(0.2)
          .toString(),
        ':focus': {
          borderColor: AppDesignScheme.Secondary,
        },
      },
      darkDropdown: {
        color: AppDesignScheme.Primary,
        background: AppDesignScheme.Tertiary,
        borderColor: AppDesignScheme.Primary,
      },
    };

    let langsDropdown = null;

    if (AppConfig.status === 'success') {
      const langOptions = AppConfig.data.Languages.map((language: Language) => {
        return (
          <option key={language.LangageId} value={language.LangageId}>
            {language.Name}
          </option>
        );
      });

      if (langOptions.length > 1) {
        langsDropdown = (
          <div className="flex flex-align-center  menu__sidepanel__item menu__sidepanel__item--select">
            <i
              className="tertiary fa fa-language"
              aria-hidden="true"
              style={isDark ? styles.primary : styles.tertiary}
            />
            <select
              aria-label={translate('Select_language')}
              className="form-control"
              value={this.state.CurrentLanguage}
              onChange={this.changeLanguage}
              style={
                isDark ? (styles.darkDropdown as any) : (styles.dropdown as any)
              }
              data-fd="sidepanel-languages-dropdown"
            >
              {langOptions}
            </select>
          </div>
        );
      }
    }

    //TODO temporary hide button
    const showPrivacySettingsLink =
      false &&
      !this.props.hasDisableNonEssentialCookies &&
      !Utilities.extraOption('data-is-elixir-site') &&
      this.props.hasGdprCookieFeatureFlag;

    return (
      <div
        className="menu__sidepanel"
        style={isDark ? styles.darkSidepanel : styles.sidepanel}
      >
        <IconField
          ariaLabel={translate('You_can_change_your_name_here')}
          icon="icon_profile"
          value={this.state.CustomerName}
          editable={true}
          handleChange={this.handleNameChange}
          placeholder={translate('Name')}
          AppDesignScheme={AppDesignScheme}
          isDark={isDark}
          dataFd="sidepanel-name"
        />
        <IconField
          icon="icon_phone"
          value={customer.CustomerPhoneNumberLocalFormatString}
          AppDesignScheme={AppDesignScheme}
          isDark={isDark}
        />
        <IconField
          ariaLabel={translate('You_can_change_your_email_here')}
          icon="icon_mail"
          value={this.state.Email}
          editable={true}
          handleChange={this.handleEmailChange}
          handleBlur={this.handleEmailBlur}
          AppDesignScheme={AppDesignScheme}
          isDark={isDark}
          placeholder={translate('Email')}
          dataFd="sidepanel-email"
        />

        <LinkField
          dataFd="sidepanel-payment-methods"
          iconClassName="icon_creditcard"
          id="payment-methods"
          textId="Payment_methods"
          to={`/payment/${Params.vrid}/${Params.type}/${Params.id}`}
        />

        {showPrivacySettingsLink && (
          <LinkField
            dataFd="sidepanel-privacy-settings"
            iconClassName="icon_lock_alt"
            id="privacy-settings"
            onClick={this.handlePrivacySettingsClick}
            textId="Privacy_Settings"
          />
        )}

        {this.renderContactUs()}

        <CheckBoxOld
          textId="Receive_promotions"
          dataFd="sidepanel-promotions-checkbox"
          onChange={this.onPromotionsClick}
          AppDesignScheme={AppDesignScheme}
          isDark={isDark}
          checked={customer.SmsPromotionsEnabled}
        />

        {langsDropdown}
        <LinkField
          dataFd="sidepanel-logout"
          iconClassName="fa fa-power-off"
          id="log-out"
          onClick={this.props.LogOut}
          textId="Log_out"
        />

        <AboutMyData
          style={{ marginTop: '8px' }}
          translate={translate}
          isPaymentWarning={true}
        />
      </div>
    );
  }

  public loggedOut(): JSX.Element {
    const { AppDesignScheme } = this.props;

    const styles = {
      sidepanel: {
        background: tinycolor(AppDesignScheme.Primary)
          .darken(3)
          .toString(),
        boxShadow: `1px 1px 9px -5px ${AppDesignScheme.Secondary}`,
        borderColor: tinycolor(AppDesignScheme.Primary)
          .darken(20)
          .toString(),
      },
      buttonSecondary: {
        backgroundColor: AppDesignScheme.Secondary,
        ':hover': {},
        ':active': {},
        ':focus': {},
      },
      buttonActive: {
        backgroundColor: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString(),
      },
      buttonHover: {
        backgroundColor: tinycolor(AppDesignScheme.Secondary)
          .darken(5)
          .toString(),
      },
      primary: {
        color: AppDesignScheme.Primary,
      },
    };

    return (
      <div className="menu__sidepanel" style={styles.sidepanel}>
        {this.renderContactUs()}
        <button
          className="fd-button fd-button--full-width fd-button--secondary"
          onClick={this.props.RequestLogIn}
          key="login-button"
          data-fd="button-login"
          style={
            [
              styles.buttonSecondary,
              Radium.getState(this.state, 'login-button', ':active')
                ? styles.buttonActive
                : Radium.getState(this.state, 'login-button', ':hover')
                ? styles.buttonHover
                : null,
            ] as any
          }
        >
          <p className="clear-margins primary fd-h4" style={styles.primary}>
            {this.props.translate('Login')}
          </p>
        </button>
      </div>
    );
  }

  public renderCustomer(customer: Data.Async<Customer>) {
    if (customer.status === 'success' && customer.data.IsGuest) {
      return this.guestLoggedIn();
    }

    switch (customer.status) {
      case 'success':
        return this.loggedIn(customer.data);
      case 'none':
        return this.loggedOut();
      case 'pending':
        return this.loading();
    }
  }

  public render(): JSX.Element {
    return <div>{this.renderCustomer(this.props.Customer)}</div>;
  }
}

const mapStateToProps = (state: Store.State): MappedState => {
  return {
    hasGdprCookieFeatureFlag: cookieSelectors.hasGdprCookieFeatureFlag(state),
    hasDisableNonEssentialCookies: cookieSelectors.hasDisableNonEssentialCookies(
      state,
    ),
  };
};

export default connect<MappedState, {}, InnerProps>(mapStateToProps)(
  Radium(StatusDisplay),
);
